<template>
	<div class="c-script-select-ad">
		<h3>Choose a source ad</h3>
		<small> *Only video ads can be selected at the moment </small>
		<FormScriptAd :adId="form.sourceAdId" @onSubmit="onSubmit"></FormScriptAd>
	</div>
</template>

<script>
import FormScriptAd from '@swipekit/components/form/form-script-ad.vue';

export default {
	components: {
		FormScriptAd,
	},

	props: {
		form: {},
	},

	methods: {
		next: function () {
			this.$emit('next');
		},
		onSubmit: function (obj) {
			let form = {
				ad: obj.ad,
			};
			this.$emit('next', form);
		},
	},
};
</script>

<style lang="scss">
.c-script-select-ad {
	margin: 0 auto;
	width: var(--page-width);
	background-color: var(--color-bg-1);
	padding: 1rem;
	border-radius: 0.5rem;
	border: var(--color-bg-3) solid 1px;

	h3 {
		text-align: center;
		margin-bottom: 0.5rem;
	}

	> small {
		display: block;
		text-align: center;
		margin-bottom: 1rem;
	}
}
</style>
